import { render, staticRenderFns } from "./DialogAddEditTournamentLive.vue?vue&type=template&id=0f9d2e88&scoped=true"
import script from "./DialogAddEditTournamentLive.js?vue&type=script&lang=js&external"
export * from "./DialogAddEditTournamentLive.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9d2e88",
  null
  
)

export default component.exports